export const COMPANY_FETCH_REQUEST = 'gustav/settings/COMPANY_FETCH_REQUEST';
export const COMPANY_FETCH_SUCCESS = 'gustav/settings/COMPANY_FETCH_SUCCESS';
export const COMPANY_FETCH_ERROR = 'gustav/settings/COMPANY_FETCH_ERROR';

export const COMPANY_UPDATE_REQUEST = 'gustav/settings/COMPANY_UPDATE_REQUEST';
export const COMPANY_UPDATE_SUCCESS = 'gustav/settings/COMPANY_UPDATE_SUCCESS';
export const COMPANY_UPDATE_ERROR = 'gustav/settings/COMPANY_UPDATE_ERROR';
